<template>
  <div class="home">
    <img :src="$dyyy(1)" alt="" srcset="" @click="$router.push('/dyyy/safe/tool')">
    <ul class="content margin-lr-8 bg-white radius padding-lr-24">
      <li class="flex justify-between align-center padding-tb-16 border-bottom" v-for="item in menu" :key="item.id" @click="$router.push(item.path)">
        <div class="flex">
          <img :src="$dyyy(item.icon)" width="38px" height="38px">
          <div class="margin-left-8">
            <div class="text-bold">{{ item.name }}</div>
            <div class="text-10 text-grey1 margin-top-4">{{ item.describe }}</div>
          </div>
        </div>
        <van-icon name="arrow" />
      </li>
    </ul>
    <img class="margin-top-16" :src="$dyyy(5)" alt="" @click="$router.push('/dyyy/safe/no-inline')">
    <img class="margin-top-16" :src="$dyyy(44)" alt="" @click="$router.push('/dyyy/safe/note')">
    <div class="margin-top-36 center-flex-y">
      <div class="bg-grey2 padding-lr-20 padding-tb-6 radius-6" @click="concatKf">
        <span>联系客服</span>
      </div>
      <div class="home-footer text-12 text-grey1 home-footer margin-top-28 flex flex-center">
        滇约易游服务中心
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Divider } from 'vant'
import { KF_PHONE } from '@/utils/constant'
import { handleApp } from '@/utils/handle_app'

Vue.use(Divider)
export default {
  data () {
    return {
      menu: [
        {
          id: 1,
          icon: '2',
          name: '安全出行',
          describe: '用心守护 安全出行',
          path: '/dyyy/safe'
        },
        {
          id: 2,
          icon: '3',
          name: '规则中心',
          describe: '明确责任 出行有序',
          path: '/dyyy/rule'
        },
        {
          id: 3,
          icon: '4',
          name: '功能指南',
          describe: '轻松几步 学会操作',
          path: '/dyyy/function'
        }
      ]
    }
  },
  methods: {
    concatKf () {
      handleApp('call', {
        phone: KF_PHONE
      }, () => {
        window.location.href = `tel:${KF_PHONE}`
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  .content {
    position: relative;
    margin-top: -16px;
  }
}

.home-footer {
  position: relative;
  &::before, &::after {
    content: "";
    display: block;
    position: absolute;
    width: 20px;
    height: 1px;
    background-color: $grey1;
    top: 50%;
    transform: scaleY(.5) translateY(-50%);
  }
  &::before {
    left: -30px;

  }
  &::after {
    right: -30px;

  }
}
</style>
